import PantryContainer from './pantry_container'

export default PantryContainer
